import "@hotwired/turbo-rails"
import "../controllers"

import '../style/application.sass'
import 'bootstrap'

import { Turbo } from "@hotwired/turbo-rails"
import { initDrawBox } from "../lib/drawBox"

// TODO: sensors - review if all necessary
document.addEventListener('turbo:load', () => {
    console.log("uno")
    initDrawBox()
})
document.addEventListener('turbo:frame-load', () => {
    console.log("due")
    initDrawBox()
})
document.addEventListener("turbo:render", () => {
    console.log("tre")
    initDrawBox()
})
